<template>
	<div class="  bg-color--dark--1 h-min-100vh">
		<b-container>
			<b-navbar type="dark" variant="fade">
				<b-navbar-brand href="/" class="align-right">
					<b-img
						left
						src="/assets/logo.png"
						alt="brand-logo"
						width="80px"
						height="80px"
					></b-img>
				</b-navbar-brand>
			</b-navbar>
		</b-container>

		<div class="svg-shape--top w-100 opacity--05">
			<img src="/assets/img/wave-8.svg" alt="wave" class="svg fill--white" />
		</div>
		<!-- end of whole area svg bg -->
		<div class="svg-shape--top opacity--10">
			<img src="/assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
		</div>
		<section class=" align-items-center ">
			<h1 class="text-white mt-0 pt-2   mb-6">
				<center>{{ first_name }} {{ last_name }}</center>
			</h1>

			<transition name="fade" enter-active-class="animated fadeIn">
				<b-container >
					<b-row class="justify-content-md-center">
						<b-col col="9" class="container-for-background">
						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							id="normal"
							v-if="!showUR && !showUL"
						>
							<b-col
								sm="12"
								md="5"
								:class="{ red: !disable_ur, m_red: disable_ur }"
								class="my-4"
								@mouseover="(hover_ur = true), (hover_ul = false)"
								@mouseleave="(hover_ur = false), (hover_ul = false)"
							>
								<center>
									<b-link class="big red link" :to="{ name: 'identitiy' }">
										<h2>
											{{ $t("register.identityInfo") }}
											<span style="color:green" v-show="idenntity_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="5"
								:class="{ yellow: !disable_ul, m_yellow: disable_ul }"
								class="my-4 "
								@mouseover="(hover_ul = true), (hover_ur = false)"
								@mouseleave="(hover_ul = false), (hover_ur = false)"
							>
								<center>
									<b-link class="big yellow link" :to="{ name: 'job' }">
										<h2>
											{{ $t("register.jobInfo") }}
											<span style="color:green" v-show="job_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>

						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							id="red"
							v-if="showUR && !showUL"
						>
							<b-col
								sm="12"
								md="7"
								class="my-4 red mx-0 mx-lg-2"
								v-show="hover_ur"
								@mouseover="(hover_ur = true), (hover_ul = false)"
								@mouseleave="(hover_ur = false), (hover_ul = false)"
							>
								<center>
									<b-link class="big red link" :to="{ name: 'identitiy' }">
										<h2>
											{{ $t("register.identityInfo") }}
											<span style="color:green" v-show="idenntity_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="3"
								:class="{ yellow: !disable_ul, m_yellow: disable_ul }"
								class="my-4 yellow mx-0 mx-lg-2"
								v-show="hover_ur"
							>
								<center>
									<b-link class="big yellow link" :to="{ name: 'job' }">
										<h2>
											{{ $t("register.jobInfo") }}
											<span style="color:green" v-show="job_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>

						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							id="yellow"
							v-if="showUL && !showUR"
						>
							<b-col
								sm="12"
								md="3"
								class="my-4 red mx-0 mx-lg-2"
								:class="{ red: !disable_ur, m_red: disable_ur }"
								v-show="hover_ul"
							>
								<center>
									<b-link class="big red link" :to="{ name: 'identitiy' }">
										<h2>
											{{ $t("register.identityInfo") }}
											<span style="color:green" v-show="idenntity_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="7"
								class="my-4 yellow mx-0 mx-lg-2"
								v-show="hover_ul"
								@mouseover="(hover_ul = true), (hover_ur = false)"
								@mouseleave="(hover_ul = false), (hover_ur = false)"
							>
								<center>
									<b-link class="big yellow link" :to="{ name: 'job' }">
										<h2>
											{{ $t("register.jobInfo") }}
											<span style="color:green" v-show="job_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>

						<!-- down row -->
						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							v-if="!showDR & !showDL"
						>
							<b-col
								sm="12"
								md="5"
								class="green my-4"
								:class="{ green: !disable_dr, m_green: disable_dr }"
								@mouseover="(hover_dr = true), (hover_dl = false)"
								@mouseleave="(hover_dr = false), (hover_dl = false)"
							>
								<center>
									<b-link class="big green link" :to="{ name: 'residential' }">
										<h2>
											{{ $t("register.residentialInfo") }}
											<span style="color:green" v-show="residential_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="5"
								class="blue my-4"
								:class="{ blue: !disable_dl, m_blue: disable_dl }"
								@mouseover="(hover_dl = true), (hover_dr = false)"
								@mouseleave="(hover_dl = false), (hover_dr = false)"
							>
								<center>
									<b-link class="big blue link" :to="{ name: 'level' }">
										<h2>
											{{ $t("setLevel.setLevel") }}
											<span style="color:green" v-show="level_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>
						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							id="green"
							v-if="showDR"
						>
							<b-col
								sm="12"
								md="7"
								class="my-4 green mx-0 mx-lg-2"
								v-show="hover_dr"
								@mouseover="(hover_dr = true), (hover_dl = false)"
								@mouseleave="(hover_dr = false), (hover_dl = false)"
							>
								<center>
									<b-link class="big green link" :to="{ name: 'residential' }">
										<h2>
											{{ $t("register.residentialInfo") }}
											<span style="color:green" v-show="residential_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="3"
								:class="{ blue: !disable_dl, m_blue: disable_dl }"
								class="my-4 blue mx-0 mx-lg-2"
								v-show="hover_dr"
							>
								<center>
									<b-link class="big blue link" :to="{ name: 'level' }">
										<h2>
											{{ $t("setLevel.setLevel") }}
											<span style="color:green" v-show="level_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>

						<div
							class="px-4  d-flex flex-column flex-lg-row justify-content-lg-between"
							id="blue"
							v-if="showDL"
						>
							<b-col
								sm="12"
								md="3"
								class="my-4 green mx-0 mx-lg-2"
								:class="{ green: !disable_dr, m_green: disable_dr }"
								v-show="hover_dl"
							>
								<center>
									<b-link class="big green link" :to="{ name: 'residential' }">
										<h2>
											{{ $t("register.residentialInfo") }}
											<span style="color:green" v-show="residential_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
							<b-col
								sm="12"
								md="7"
								class="my-4 blue mx-0 mx-lg-2"
								v-show="hover_dl"
								@mouseover="(hover_dl = true), (hover_dr = false)"
								@mouseleave="(hover_dl = false), (hover_dr = false)"
							>
								<center>
									<b-link class="big blue link" :to="{ name: 'level' }">
										<h2>
											{{ $t("setLevel.setLevel") }}
											<span style="color:green" v-show="level_completed"
												><i class="fas fa-check "></i>
											</span>
										</h2>
									</b-link>
								</center>
							</b-col>
						</div>
						</b-col>
					</b-row>
				</b-container>
			</transition>
		</section>
	</div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

export default {
	data() {
		return {
			first_name: "",
			last_name: "",
			hover: false,
			hover_ur: false,
			hover_ul: false,
			disable_ur: false,
			disable_ul: false,
			showU: true,
			showUR: false,
			showUL: false,

			hover_dl: false,
			hover_dr: false,
			disable_dr: false,
			disable_dl: false,
			showD: true,
			showDR: false,
			showDL: false,
		};
	},
	mounted() {
		console.log(
			"currentCustomer:**********" +
				JSON.stringify(this.$store.getters.getCustomer),
		);
		if (!localStorage.getItem("SupplierCustomerId")) {
			this.getCostomer();
		} else {
			this.getSupplierInfo();
		}

		this.showDashboard();
	},
	watch: {
		hover_ur: function() {
			if (!this.disable_ur) {
				if (this.hover_ur) {
					this.showUR = true;
				} else {
					this.showUR = false;
				}
			} else {
				this.showUR = false;
			}
		},
		hover_ul: function() {
			if (!this.disable_ul) {
				if (this.hover_ul) {
					this.showUL = true;
				} else {
					this.showUL = false;
				}
			} else {
				this.showUL = false;
			}
		},

		hover_dr: function() {
			if (!this.disable_dr) {
				if (this.hover_dr) {
					this.showDR = true;
				} else {
					this.showDR = false;
				}
			} else {
				this.showUR = false;
			}
		},
		hover_dl: function() {
			if (!this.disable_dl) {
				if (this.hover_dl) {
					this.showDL = true;
				} else {
					this.showDL = false;
				}
			} else {
				this.showDL = false;
			}
		},
	},
	computed: {
		idenntity_completed() {
			console.log(
				"firstName: ********************" +
					this.$store.getters.getCustomer.first_name,
			);
			if (this.$store.getters.getCustomer.first_name) {
				return true;
			}
			return false;
		},
		job_completed() {
			console.log("job **********" + this.$store.getters.getCustomer.job);
			if (this.$store.getters.getCustomer.job) {
				return true;
			}
			return false;
		},
		residential_completed() {
			console.log("personalhome", this.$store.getters.getCustomer.personalhome);
			if (
				this.$store.getters.getCustomer.organizationhome ||
				this.$store.getters.getCustomer.rentalhome ||
				this.$store.getters.getCustomer.personalhome
			) {
				return true;
			}
			return false;
		},
		level_completed() {
			if (this.$store.getters.getCustomer.checkinfo) {
				if (this.$store.getters.getCustomer.checkinfo.sayyad_number) {
					return true;
				}
			}

			return false;
		},
	},
	methods: {
		getSupplierInfo() {
			this.$store
				.dispatch("getSupplierInfo")
				.then((resp) => {
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getCostomer() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getCustomer")
				.then((response) => {
					this.showDashboard();
					console.log(response);
					load.hide();
					this.first_name = response.body.first_name;
					this.last_name = response.body.last_name;
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.error);
					load.hide();
				});
		},
		showDashboard() {
			console.log("identity: " + this.idenntity_completed);
			console.log("residential: " + this.residential_completed);
			console.log("job: " + this.job);

			if (
				this.idenntity_completed &&
				this.job_completed &&
				this.residential_completed &&
				this.level_completed
			) {
				if (!localStorage.getItem("SupplierCustomerId")) {
					this.$router.push("/customer/IdentityInfo");
					this.$noty.success(this.$t("ثبت نام با موفقیت انجام شد"));
				} else {
					localStorage.removeItem("SupplierCustomerId");
					this.$router.push("/supplier");
					this.$noty.success(this.$t("اطلاعات کامل شده است"));
				}
			}
		},
	},
};
</script>

<style scoped>
.active {
	background: green;
	height: 40%;
	width: 40%;
}
.red {
	background-color: #ff8800;
	border-radius: 5%;
}
.m_red {
	background-color: rgb(233, 150, 150);
}
.yellow {
	background-color: #fda600;
	border-radius: 5%;
}
.m_yellow {
	background-color: #fbc400;
}
.green {
	background-color: #fbd500;
	border-radius: 5%;
}

.blue {
	background-color: #f9e100;
	border-radius: 5%;
}
.big {
	height: 200px;
	width: 200;
}
.container-for-background {
	background-color: rgba(255, 255, 255, 0.733);
	opacity: 0.85;
	border-radius: 5%;
	border: solid 8px;
	border-color: aliceblue;
}
.link {
	color: black;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-decoration: none;
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css"></style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
